/**
 * Send newsletter signup request via AJAX
 *
 * @package LightweightBaseline
 */

/**
 * Send newsletter signup request
 *
 * @param {string} email
 * @param {string} nonce
 * @param {string} ajaxUrl
 * @param {string} subSource
 * @param {string} brandName
 * @returns {Promise<Object>}
 */
export async function sendSignupRequest(
  email,
  nonce,
  ajaxUrl,
  subSource,
  brandName
) {
  const formData = new FormData();
  formData.append('action', 'newsletter_signup');
  formData.append('email', email);
  formData.append('nonce', nonce);
  if (subSource) {
    formData.append('sub_source', subSource);
  }
  if (brandName) {
    formData.append('brand_name', brandName);
  }

  try {
    // WP sends structured JSON on both 2xx and error responses, so we always parse.
    const response = await fetch(ajaxUrl, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
    });

    try {
      return await response.json();
    } catch (_parseError) {
      return {
        success: false,
        data: {
          message: `Unexpected server response (HTTP ${response.status}).`,
        },
      };
    }
  } catch (error) {
    return {
      success: false,
      data: {
        message: error.message || 'Network error. Please try again.',
      },
    };
  }
}
